<template>
  <div class="bto-sb-event-odds">
    <div class="bto-sb-event-odds-left">
      <div
        class="bto-sb-event-name"
        @mousemove="showOddPopup($event, item.name)"
        @mouseleave="hideOddPopup">
        <router-link :to="getMatchRoute()">
          <div class="bto-sb-event-wrap">
            <span class="bto-sb-event-team">
              <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="item.awayAtHome ? item.guestTeamIcon : item.homeTeamIcon" >
                <span class="bto-sb-event-team-logo bto-sb-event-hometeam-logo" v-if="url" v-show="loaded">
                  <img :src="url" alt="" @error="reset" @load="onLoad" />
                </span>
              </logo-component>
              <span class="bto-sb-event-home">
                {{ item.awayAtHome ? item.guestTeam : item.homeTeam }}
              </span>
              <span class="bto-sb-event-score bto-sb-event-score-home" v-if="item.scoresToDisplay">
                <i v-for="(_, i) in item.scoresToDisplay" :key="i">
                  {{ item.awayAtHome ? item.allScores[i].away : item.allScores[i].home }}
                </i>
              </span>
            </span>
            <span
              class="bto-sb-event-score-vs"
              :class="{ 'bto-sb-event-score-us': item.awayAtHome }">
              <i>{{ item.awayAtHome ? "@" : t("Mobile.VS") }}</i>
            </span>
            <span class="bto-sb-event-team">
              <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="item.awayAtHome ? item.homeTeamIcon : item.guestTeamIcon" >
                <span class="bto-sb-event-team-logo bto-sb-event-awayteam-logo" v-if="url" v-show="loaded">
                  <img :src="url" alt="" @error="reset"  @load="onLoad" />
                </span>
              </logo-component>
              <span class="bto-sb-event-away">
                {{ item.awayAtHome ? item.homeTeam : item.guestTeam }}
              </span>
              <span class="bto-sb-event-score bto-sb-event-score-home" v-if="item.scoresToDisplay">
                <i v-for="(_, i) in item.scoresToDisplay" :key="i">
                  {{ item.awayAtHome ? item.allScores[i].home : item.allScores[i].away }}
                </i>
              </span>
            </span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="bto-sb-event-odds-right">
      <div class="bto-sb-event-odds-cell" v-if="is3WaySport">
        <match-odd-us
          v-for="(outcome, index) in threeWayMarket.outcomes"
          v-bind:match="item"
          v-bind:odd="threeWayMarket"
          v-bind:outcome="outcome"
          v-bind:key="index" />
      </div>
      <template v-if="!is3WaySport">
        <div class="bto-sb-event-odds-cell" v-for="(n, idx) in 2" :key="n">
          <match-odd-us
            v-if="firstMarket"
            v-bind:match="item"
            v-bind:odd="firstMarket"
            v-bind:label="getOutcomeLabel(0, n)"
            v-bind:outcome="firstMarket.outcomes[idx]" />
          <match-odd-us
            v-if="secondMarket"
            v-bind:match="item"
            v-bind:odd="secondMarket"
            v-bind:label="getOutcomeLabel(1, n)"
            v-bind:outcome="secondMarket.outcomes[idx] || {}" />
          <match-odd-us
            v-if="thirdMarket"
            v-bind:match="item"
            v-bind:odd="thirdMarket"
            v-bind:label="getOutcomeLabel(2, n)"
            v-bind:outcome="thirdMarket.outcomes[idx] || {}" />
        </div>
      </template>
    </div>
    <div class="bto-sb-event-odds-full" v-if="!isInMatchDetails">
      <div class="bto-sb-event-odds-left">
        <div class="bto-sb-event-odds-info-cell">
          <span
            v-if="item.hasLiveStream && isLive"
            class="bto-sb-event-livestream"
            :class="{ 'bto-sb-event-time-live': isLive }">
            <i class="bto-app-live-stream-o"></i>
          </span>
          <favorite-component v-if="showFavorites" :match="item" />
          <span v-if="isLive" class="bto-sb-event-time bto-sb-event-time-live">
            <i v-if="item.time">{{ item.time }}</i>
            {{ t(item.status) }}
          </span>
          <span v-else class="bto-sb-event-time">
            <i>{{ item.date }} {{ item.time }}</i>
          </span>
          <span class="bto-sb-event-cashout" v-if="cashOutVisibility">
            <i class="bto-app-cash"></i>
          </span>
          <statistics-component v-if="showStatistics" :betRadarId="item.betRadarId" :feedProvider="item.feedProvider" :isAwayAtHome="item.awayAtHome" :isLive="item.isLiveMatch" :sportId="item.sportId" :tournamentName="item.tournamentName"/>
        </div>
      </div>
      <div class="bto-sb-event-odds-right">
        <router-link class="bto-sb-event-more-odd" :to="getMatchRoute()">
          +{{ showMarketsInMatch === true ? item.numberOfMarkets : item.numberOfOdds }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import store from '../../../store';
  import OddHelperService from '../../../services/odd-helper-service';
  import MatchOddUs from '../match/match-odds-us';
  import { urlFriendlyParam } from '@bto-services/utils';
  import { getOddsAtCol, getMarketLabel } from 'bto-models/match/us';
  import { EventBus } from '../../../services/event-bus-service';

  export default {
    name: 'MatchItemUs',
    components: {
      MatchOddUs
    },
    props: {
      is3WaySport: {
        type: Boolean,
        default: true,
      },
      item: {
        type: Object,
      },
      showMarketsInMatch: {
        type: Boolean,
        default: false,
      },
      showEventCode: {
        type: Boolean,
        default: false,
      },
      showTeamIcon: {
        type: Boolean,
        default: false,
      },
      showFavorites: {
        type: Boolean,
        default: false,
      },
      showStatistics: {
        type: Boolean,
        default: false,
      },
      isLive: {
        type: Boolean,
        default: false,
      },
      isInMatchDetails: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      cashOutVisibility() {
        return this.cashoutEnabledDB && this.item.cashOutVisibility &&
          (!APP_SETTINGS.player.token || this.cashoutEnabledUser);
      },
      getMarketsForUS() {
        if (this.item.isLiveMatch) {
          return this.item.marketsInfo;
        }
        return store.getters.getSportMarketsUs(this.item.sportId);
      },
      threeWayMarket() {
        const odds = getOddsAtCol(this.item, this.getMarketsForUS, 0);
        if (odds) {
          if (odds.outcomes.length < 3) {
            for (let i = 0; i < 3; i++) {
              const marketCol = odds.outcomes.some(o => o.column === i + 1);
              if (!marketCol) {
                const eo = OddHelperService.generateEmptyOutcomes(1, false);
                eo.outcomes[0].column = i + 1;
                odds.outcomes.push(eo.outcomes[0]);
              }
            }
          }
          odds.outcomes = odds.outcomes.filter(o => (+o.column) >= 0).sort((a, b) => a.column - b.column);
          return odds;
        }
        return OddHelperService.generateEmptyOutcomes(3, false);
      },
      firstMarket() {
        const odds = getOddsAtCol(this.item, this.getMarketsForUS, 0);
        if (odds) {
          return odds;
        }
        return OddHelperService.generateEmptyOutcomes(this.is3WaySport ? 3 : 2, false);
      },
      secondMarket() {
        const odds = getOddsAtCol(this.item, this.getMarketsForUS, 1);
        if (odds) {
          return odds;
        }
        if (!this.getMarketsForUS[1]) {
          return;
        }
        return OddHelperService.generateEmptyOutcomes(this.is3WaySport ? 3 : 2, false);
      },
      thirdMarket() {
        const odds = getOddsAtCol(this.item, this.getMarketsForUS, 2);
        if (odds) {
          return odds;
        }
        if (!this.getMarketsForUS[2]) {
          return;
        }
        return OddHelperService.generateEmptyOutcomes(this.is3WaySport ? 3 : 2, false);
      },
    },
    methods: {
      getMatchRoute() {
        const rawSportName = store.getters.getSportName(this.item.sportId);
        const sportName = urlFriendlyParam(rawSportName || '');
        const categoryName = urlFriendlyParam(this.item.tournamentName);
        const eventName = urlFriendlyParam(`${this.item.homeTeam} vs ${this.item.guestTeam}`);
        if (this.isLive) {
          return { name: 'seoGameLive', params: { sportName, categoryName, eventName, matchId: this.item.betRadarId } };
        }
        return { name: 'seoGame', params: { sportName, categoryName, eventName, matchId: this.item.matchId } };
      },
      /**
       * Get label for given outcome
       * @param {number} col - odd column
       * @param {number} row - odd row
       */
      getOutcomeLabel(col, row) {
        return getMarketLabel(this.getMarketsForUS, this.item.awayAtHome, col, row);
      },
      showOddPopup(event, msg) {
        EventBus.$emit('showoddmarketpopup', {
          message: msg,
          e: event
        });
      },
      hideOddPopup() {
        EventBus.$emit('hideoddmarketpopup');
      }
    }
  };
</script>